
import { mapState } from "pinia";
import {
  displayCoordinates,
  formatValue,
  getCurrencySign,
  getRagIconUrl,
} from "@/util/helpers";
import { DatasetRecord } from "@/types/DatasetRecord";
import { Point } from "geojson";
import { useGammaData, useLocation, useOrgSettings } from "@/services";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ClaimsTable",
  data: () => ({
    fields: [
      "policyRiskId",
      { key: "riskType", label: "Type" },
      { key: "claimIncurred", label: "Claim Incurred" },
      { key: "formattedAddress", label: "Address" },
      "buildingId",
      "coverHolder",
    ],
  }),
  computed: {
    ...mapState(useOrgSettings, ["currencySymbol"]),
    claims(): DatasetRecord[] {
      return useGammaData().visibleClaims;
    },
  },
  methods: {
    formatValue,
    getCurrencySign,
    getRagIconUrl,
    displayCoordinates,
    iconTooltip(value: string) {
      return {
        title: value,
        animation: false,
        container: "app",
        placement: "left",
      };
    },
    setActiveEntry(record: DatasetRecord) {
      useLocation().updateLocation({
        record,
        type: record.recordType,
        geometry: record.geometry as Point,
      });
    },
  },
});
